import { BaseDto } from './base.dto';

export class CityDto extends BaseDto {
  countryId: number;
  name: string;
  code: string;
  startDate: Date;
  endDate: Date;
}
